import { Component, inject } from '@angular/core';
import { AuthService } from '@app/services/auth.service';

@Component({
  selector: 'app-logout-page',
  standalone: true,
  imports: [],
  template: `
    <div class="flex items-center justify-center p-2 md:p-8">...</div>
  `,
  styles: [],
})
export class LogoutPageComponent {
  authService = inject(AuthService);

  constructor() {
    this.authService.logout();
  }
}
